import React from 'react';
import PropTypes from 'prop-types';
import {
  Step,
  Icon,
} from 'semantic-ui-react';

const NewCampaignSteps = ({
  stepIndex,
  onStepClick,
}) =>
  <Step.Group fluid>
    <Step active={stepIndex === 1} onClick={stepIndex > 1 && (() => onStepClick(1))}>
      <Icon name="folder" />
      <Step.Content>
        <Step.Title>Campaign Type</Step.Title>
        <Step.Description>Choose your campaign type</Step.Description>
      </Step.Content>
    </Step>

    <Step active={stepIndex === 2} disabled={stepIndex < 2}>
      <Icon name="list" />
      <Step.Content>
        <Step.Title>Campaign Details</Step.Title>
        <Step.Description>Complete your setup</Step.Description>
      </Step.Content>
    </Step>
  </Step.Group>;

NewCampaignSteps.propTypes = {
  stepIndex: PropTypes.number.isRequired,
  onStepClick: PropTypes.func.isRequired,
};

export default NewCampaignSteps;



/** WEBPACK FOOTER **
 ** ./src/components/new-add-campaign-modal/new-campaign-steps.js
 **/